import { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string;
}

const faqData: FAQItem[] = [
  {
    question: '「好色小姨」是什么类型的角色？',
    answer: '「好色小姨」是都市言情与家庭伦理小说中的经典角色类型，通常指代小说中男主角的小姨（妻子的妹妹或母亲的妹妹），因其性格大胆、行为主动、充满欲望张力而成为小说中极具戏剧性的关键角色。她往往在家庭伦理与个人情感之间制造强烈的冲突与张力。',
  },
  {
    question: '这个平台的主要内容是什么？',
    answer: '我们的平台围绕「好色小姨」这一角色类型，提供四大板块的内容：人物分析（深度剖析角色性格与文学价值）、故事合集（精选经典情节与小说推荐）、创作灵感（为创作者提供角色塑造方法论与创新思路）、情感逻辑（从心理学和伦理学角度解读角色行为）。',
  },
  {
    question: '这里的文章适合谁阅读？',
    answer: '我们的内容面向都市言情小说爱好者、网络文学读者、小说创作者以及文学研究者。无论你是想找好看的小说推荐，还是想深入了解角色背后的心理逻辑，或者想为自己的创作寻找灵感，这里都有适合你的内容。',
  },
  {
    question: '如何找到特定类型的文章？',
    answer: '你可以通过页面顶部的导航栏直接进入四大分类板块（人物分析、故事合集、创作灵感、情感逻辑），也可以在首页浏览编辑精选的内容。每个分类页面都包含了该类别下的全部文章。',
  },
  {
    question: '平台的文章多久更新一次？',
    answer: '我们保持每周更新 2-3 篇高质量原创文章，内容涵盖角色分析、小说推荐、创作指导和心理洞察。你可以关注我们的微信公众号获取最新更新通知。',
  },
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqData.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  };

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
      <div className="w-full max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
            常见问题
          </h2>
          <p className="text-sm text-foreground-600 mt-2">
            关于好色小姨故事集的常见问题解答
          </p>
        </div>

        <div className="space-y-3">
          {faqData.map((item, index) => (
            <div
              key={index}
              className="bg-background-50 border border-background-200/70 rounded-xl overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between px-6 py-4 text-left"
              >
                <h4 className="text-sm font-medium text-foreground-900 pr-4">
                  {item.question}
                </h4>
                <i
                  className={`ri-arrow-down-s-line text-foreground-500 transition-transform duration-300 flex-shrink-0 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96 pb-4' : 'max-h-0'
                }`}
              >
                <p className="px-6 text-sm text-foreground-600 leading-relaxed">
                  {item.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}